import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
// filters
import './modules/fptai/filters/filters'
// plugins
import i18n from './plugins/i18n'
import vuetify from '@/plugins/vuetify'
import './plugins/axios'
import './plugins/vue-notification'
import './plugins/gtag'
import './plugins/element-ui'
import './plugins/vuex-pathify'
import './plugins/json-viewer'
// import './plugins/bootstrap-vue'
// app included
import '@/utils/utils'
import '@/utils/const'
import '@/store/store.type'
import '@/eventbus/app.eventbus'
import '@/services/app.service'
// style
import '@/assets/css/common.scss'
import '@/assets/css/fci-class.scss'
import '@/assets/css/tm.scss'
import '@/assets/css/index.scss'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false

window.vueapp = new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount('#app')
